import { HighPriorityNovaModalContainer } from "@nova/component-nova-modal-container"
import { useAppDispatch } from "integrations/redux/hooks"
import { hideGlobalModal, showGlobalModal } from "runlevel/actions"
import { ModalNames } from "./types"
import { initializeCenterModalForComponentAction } from "features/content-overlay/slice"
import { ButtonSecondary } from "@nova/component-btn"
import { getBrowserDetector } from "@nova/util-browser"
import store from "integrations/redux/store"

const BrowserAlertModal = () => {
    const dispatch = useAppDispatch()

    return (
        <HighPriorityNovaModalContainer
            title="Best in Google Chrome"
            bottomBar={
                <div className="flex w-full justify-end">
                    <ButtonSecondary onClick={() => dispatch(hideGlobalModal())} title="Continue" />
                </div>
            }
            closeModal={() => dispatch(hideGlobalModal())}
            className="max-w-[400px] w-full"
        >
            <h4 className="text-center">
                We recommend using Nova in Google Chrome for the smoothest performance and feature
                support.
            </h4>
        </HighPriorityNovaModalContainer>
    )
}

let hasDisplayed = false
const browserAlertModal = () => {
    const browserDetector = getBrowserDetector()

    if (!browserDetector.isChrome() && !hasDisplayed) {
        store.dispatch(initializeCenterModalForComponentAction(ModalNames.BrowserAlertModal))
        store.dispatch(showGlobalModal())
        hasDisplayed = true
    }
}

export { BrowserAlertModal, browserAlertModal }
